import { ICalcContext, ICalculatedProductResult } from "@biz/projectCalculation/ProjectDefinitions";
import { SCProductData } from "@biz/sc/IShopData";

export class CalcSCLogic {
  static calculateProduct(data: SCProductData, _slc: ICalcContext): ICalculatedProductResult {
    return {
      id: data.id,
      pd: data.pd,
      articles: {},
      errors: [],
      infos: [],
      errorMap: {},
      product: data
    }
  }
}